// ADD TO CART SHORTCODE
(function () {

  const content = document.querySelector('[itemprop="articleBody"], .rte, .article-template__content');
  if (!content) return;

  // Replace shortcode with button
  content.innerHTML = content.innerHTML.replace(
    /\[add-to-cart\s+id="(\d+)"\]/g,
    (match, id) => {
      return `<button class="bw-add-to-cart-btn" data-variant-id="${id}">
                Add to Cart
              </button>`;
    }
  );

})();

// HANDLE ADD TO CART CLICK
document.addEventListener('click', async function(e) {

  if (!e.target.classList.contains('bw-add-to-cart-btn')) return;

  const btn = e.target;
  const variantId = btn.dataset.variantId;

  if (!variantId) return;

  btn.innerText = 'Adding...';
  btn.disabled = true;

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    });

    if (!res.ok) throw new Error('Cart error');

    btn.innerText = 'Added ✓';

  } catch (err) {
    console.error(err);
    btn.innerText = 'Error';
  }

  setTimeout(() => {
    btn.innerText = 'Add to Cart';
    btn.disabled = false;
  }, 2000);

});

